import React, { useState, useEffect } from "react";
import Tile from "../Tile/Tile";
import styles from "./Board.module.css";
import tropy from "../../images/tropy.webp";
import { useSelector } from "react-redux";
import { wonGame } from "../../redux/types/userModeTypes";
import { arrayLength } from "../../config";
const Board = () => {
  const userMode = useSelector((state) => state.userMode);
  const gameData = useSelector((state) => state.gameData);
  const gameSettings = useSelector((state) => state.gameSettings);

  const [showWinMessage, setShowWinMessage] = useState(false);
  const [currentMultiplier, setCurrentMultiplier] = useState(0);
  const [showBetAmount, setBetAmount] = useState(0);

  useEffect(() => {
    if (userMode.matchState === wonGame) {
      setShowWinMessage(true);
      setWinInfo();
    } else {
      setShowWinMessage(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userMode.matchState]);

  const setWinInfo = () => {
    setCurrentMultiplier(gameData.currentMultiplier.toFixed(2));
    setBetAmount(
      (gameSettings.betAmount * gameData.currentMultiplier).toFixed(2)
    );
  };

  const tiles = Array(arrayLength)
    .fill()
    .map((_, index) => <Tile key={index} index={index} />);

  return (
    <div className={styles.board}>
      {tiles}
      {showWinMessage ? (
        <div className={styles.wonMessagesContainer}>
          <div className={styles.wonMessagesWrapper}>
            <div className={styles.wonMessages}>
              <img src={tropy} alt="tropy" className={styles.tropyImage} />

              <div className={styles.messageTitle}>
                {`X${currentMultiplier}`}
              </div>
              <div className={styles.message}>{`$${showBetAmount}`}</div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Board;
